import React from 'react';

const WINDOW_POSITIONS = [
  // wide block
  [40, 215], [70, 215], [100, 215], [130, 215], [50, 250], [80, 250], [110, 250],
  // classic skyscraper
  [180, 140], [200, 160], [220, 140], [180, 200], [200, 220], [220, 200], [180, 250], [220, 250],
  // mid block
  [370, 175], [390, 195], [410, 175], [370, 220], [390, 240], [410, 220],
  // dome
  [465, 220], [485, 250], [505, 220], [525, 250],
  // slim spire
  [570, 130], [590, 150], [580, 200], [570, 240], [600, 240],
  // wide office
  [660, 165], [685, 185], [710, 165], [730, 205], [660, 225], [685, 245], [710, 225],
  // pencil tower
  [770, 90], [770, 130], [770, 170], [770, 210], [770, 250],
  // cathedral
  [900, 250],
  // tall flat skyscraper
  [965, 90], [985, 110], [965, 150], [985, 170], [965, 200], [985, 220], [965, 250],
  // stepped pyramid
  [1085, 200], [1120, 160], [1150, 200], [1185, 240],
  // apartment block
  [1340, 160], [1360, 180], [1380, 160], [1340, 210], [1360, 230], [1380, 210],
  // factory
  [1425, 230], [1445, 230], [1490, 240],
  // last skyscrapers
  [1530, 130], [1545, 150], [1530, 180], [1545, 210], [1530, 240],
  [1585, 180], [1595, 220],
];

const SkylineWindows = ({ accentAlt }) => (
  <g fill={accentAlt}>
    {WINDOW_POSITIONS.map(([x, y], i) => (
      <rect
        key={`city-2-${i}`}
        className="cs-win"
        x={x}
        y={y}
        width="3"
        height="3"
        style={{ animationDelay: `${(i * 277) % 6400}ms` }}
      />
    ))}
  </g>
);

export default SkylineWindows;
